// extracted by mini-css-extract-plugin
module.exports = {"page":"_10709","hd":"_13744"};